module.exports = __webpack_public_path__ + "HomeSearch-3PV7iK2.svg";